export default __webpack_public_path__ + "static/j2-1e1c2e6fc1357d29acb262ece70c009c.jpg";